import type { Locale } from "../content/types";

export function getLocaleFromPath(pathname: string): Locale {
  // 先判繁体再判简体:两个分支都带斜杠边界(=== 或 startsWith("/xxx/")),
  // 顺序对了更不容易在后续改动中被图省事的 startsWith("/zh") 吞掉
  if (pathname === "/zh-Hant" || pathname.startsWith("/zh-Hant/")) return "zh-Hant";
  if (pathname === "/zh" || pathname.startsWith("/zh/")) return "zh";
  return "en";
}

export function stripLocalePrefix(pathname: string): string {
  return pathname.replace(/^\/zh-Hant(?=\/|$)/, "").replace(/^\/zh(?=\/|$)/, "") || "/";
}

export function getLocalizedPath(pathname: string, targetLocale: Locale): string {
  const withoutLocale = stripLocalePrefix(pathname);

  if (targetLocale === "zh-Hant") {
    return withoutLocale === "/" ? "/zh-Hant" : `/zh-Hant${withoutLocale}`;
  }

  if (targetLocale === "zh") {
    return withoutLocale === "/" ? "/zh" : `/zh${withoutLocale}`;
  }

  return withoutLocale;
}
